import MiniButton from "../../components/MiniButton";
import { colorsList } from "../../data/colorsList";
import { strLang } from "../../functions/strLang";

export default function MapButton({ image, onClick, mapType, mapButtonSize }) {
  return (
    <div
      style={{
        position: "absolute",
        bottom: 30,
        right: 25,
        zIndex: 100,
      }}
    >
      <MiniButton
        image={image}
        onClick={onClick}
        color={colorsList.white}
        iconSize={mapButtonSize + 5}
        shadow={true}
      />
      <div
        style={{
          position: "absolute",
          textAlign: "center",
          fontWeight: "bold",
          width: 80,
          left: "50%",
          marginTop: 5,
          marginLeft: -40,
          color: mapType === "OSM" ? colorsList.black : colorsList.white,
        }}
      >
        {strLang(mapType === "OSM" ? "satellite" : "streets")}
      </div>
    </div>
  );
}
